import { Button } from "../button";
import { cn } from "../../../lib/utils";
import * as Dialog from '@radix-ui/react-dialog';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Footer = function Footer(_ref) {
  var size = _ref.size,
    buttonVertical = _ref.buttonVertical,
    isMobile = _ref.isMobile,
    onOk = _ref.onOk,
    onCancel = _ref.onCancel,
    okText = _ref.okText,
    confirmLoading = _ref.confirmLoading,
    cancelLoading = _ref.cancelLoading,
    cancelText = _ref.cancelText,
    footer = _ref.footer,
    footerWrapper = _ref.footerWrapper,
    confirmBtnDisabled = _ref.confirmBtnDisabled;
  if (footer === false || footer === null) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  if (footer) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        marginTop: 24
      },
      className: cn({
        'px-[24px]': isMobile,
        'px-[32px]': !isMobile
      }, footerWrapper),
      children: footer
    });
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: 'flex',
      marginTop: 24,
      justifyContent: 'center'
    },
    className: cn({
      'px-[24px]': isMobile,
      'px-[32px]': !isMobile && size === 'small',
      'max-w-[496px] mx-auto': ['large', 'medium'].includes(size) && !isMobile
    }),
    children: /*#__PURE__*/_jsx(Dialog.Close, {
      asChild: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: cn('flex w-full', footerWrapper, {
          'flex-col gap-[12px]': isMobile && buttonVertical,
          'gap-[20px]': isMobile && !buttonVertical || !isMobile
        }),
        children: [okText && /*#__PURE__*/_jsx(Button, {
          className: "flex-1",
          disabled: confirmBtnDisabled,
          variant: "primary",
          loading: confirmLoading,
          onClick: function onClick() {
            onOk === null || onOk === void 0 || onOk();
          },
          children: okText
        }), cancelText && /*#__PURE__*/_jsx(Button, {
          className: "flex-1",
          variant: "secondary",
          loading: cancelLoading,
          onClick: function onClick() {
            onCancel === null || onCancel === void 0 || onCancel();
          },
          children: cancelText
        })]
      })
    })
  });
};